import type { CreateClientConfig } from '../../api/generated/client.gen';
import { apiClient } from './client';
import { BACKEND_URL } from '../../constants/config';

/**
 * Runtime configuration for @hey-api/openapi-ts generated client
 *
 * This function is called by the generated client to customize the axios instance.
 * It injects our custom axios instance with auth interceptor instead of creating a new one.
 *
 * Benefits:
 * - Survives regeneration (config file is not generated)
 * - Auth headers automatically added via interceptor
 * - Consistent error handling (401 redirect)
 * - Proper query string serialization
 * - Backend URL from centralized config (src/constants/config.ts)
 *
 * @see openapi-ts.config.ts - runtimeConfigPath points to this file
 * @see client.ts - Custom axios instance with auth interceptor
 * @see config.ts - BACKEND_URL is the single source of truth
 */
export const createClientConfig: CreateClientConfig = (config) => ({
    ...config,
    axios: apiClient,
    baseURL: BACKEND_URL,
});
